const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 551.03 551.03",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_",
    style: {
      fill: "#2b95d0"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    d: "m386.88 0h-222.72c-90.516 0-164.16 73.64-164.16 164.16v222.72c0 90.516 73.64 164.16 164.16 164.16h222.72c90.516 0 164.16-73.64 164.16-164.16v-222.72c-.001-90.516-73.641-164.16-164.16-164.16zm108.72 386.88c0 60.045-48.677 108.72-108.72 108.72h-222.72c-60.045 0-108.72-48.677-108.72-108.72v-222.72c0-60.046 48.677-108.72 108.72-108.72h222.72c60.045 0 108.72 48.676 108.72 108.72v222.72z",
    style: {
      fill: "#2b95d0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_81_",
    d: "m275.52 133c-78.584 0-142.52 63.933-142.52 142.52s63.933 142.52 142.52 142.52 142.52-63.933 142.52-142.52-63.933-142.52-142.52-142.52zm0 229.6c-48.095 0-87.083-38.988-87.083-87.083s38.989-87.083 87.083-87.083c48.095 0 87.083 38.988 87.083 87.083 0 48.094-38.989 87.083-87.083 87.083z",
    style: {
      fill: "#2b95d0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_83_",
    cx: 418.31,
    cy: 134.07,
    r: 34.149,
    style: {
      fill: "#2b95d0"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.cabc65286e949fe5098ba139163e9942.svg";
export { ForwardRef as ReactComponent };